import { InjectionToken } from '@angular/core';
import { assistantDefaults } from '../../../environments/assistant.defaults';
import { environment } from '../../../environments/assistant.runtime';

// Optional lookup preserves existing ignored local overrides during rollout.
export const assistantOptions = {
  ...assistantDefaults,
  ...(environment as { assistantOptions?: Partial<typeof assistantDefaults> }).assistantOptions,
};

/** Approved support contact is deployment configuration, never a model-generated address. */
export const ASSISTANT_SUPPORT_EMAIL = new InjectionToken<string>('Assistant support email', {
  providedIn: 'root', factory: () => environment.assistantSupportEmail,
});

export interface AssistantConfig {
  readonly maxQuestionLength: number;
  readonly responseTimeoutMs: number;
}
/** Shared UI limits, overridable through dependency injection per deployment. */
export const ASSISTANT_CONFIG = new InjectionToken<AssistantConfig>('Assistant configuration', {
  providedIn: 'root',
  // Allow the 90-second backend budget plus startup and transport time.
  factory: () => ({ maxQuestionLength: assistantOptions.maxQuestionLength, responseTimeoutMs: assistantOptions.responseTimeoutMs }),
});

export const ASSISTANT_API_CONFIG = new InjectionToken('Assistant transport configuration', {
  providedIn: 'root',
  factory: () => ({
    // Optional lookup preserves existing ignored local environment overrides.
    httpUrl: (environment as { assistantHttpUrl?: string }).assistantHttpUrl ?? '',
    requestTimeoutMs: assistantOptions.requestTimeoutMs,
    maxFrameBytes: assistantOptions.maxFrameBytes,
    maxAnswerCharacters: assistantOptions.maxAnswerCharacters,
  }),
});
